import { render } from "./ProjectsSearch.vue?vue&type=template&id=65452a1a&scoped=true&ts=true"
import script from "./ProjectsSearch.vue?vue&type=script&lang=ts"
export * from "./ProjectsSearch.vue?vue&type=script&lang=ts"

import "./ProjectsSearch.vue?vue&type=style&index=0&id=65452a1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65452a1a"]])

export default __exports__